import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  tfTitle: 'Two Factor Authentication',
  tfDescription:
    'Help protect your account from unauthorized access by enabling additional security checks when signing in. You will need to enter your password and a verification code from your phone to sign in.',
  tfCTA: 'Configure Two-Factor Authentication',
  tfCTADisable: 'Disable Two-Factor Authentication',
  tfConfigTitle: 'Protect your account in just a few steps',
  tfConfigStep1: 'Link an authentication app to your EFEX account',
  tfConfigStep1Description:
    'Use a compatible authentication app (like Google Authenticator, Authy Duo Mobile, 1Password, etc) We will generate a QR code for you to scan.',
  tfConfigStep2: 'Enter the confirmation code',
  tfConfigStep2Description:
    'Two-factor authentication will then be turned on for authentication app.',
  tfCodeScan:
    "Use your authentication app to scan the QR code. If you don't have an authentication app, you'll need to install one to continue.",
  tfCodeScanError:
    'There was an error retrieving the QR code. Please try again later.',
  tfCodeCantScan: "Can't scan the QR code?",
  tfCodeManualConfig: 'Enter the following code in your authentication app:',
  tfConfirmationCode:
    'Enter the confirmation code generated by your authentication app.',
  tfConfirmationCodeError: 'Invalid code, please try again.',
  tfDisable90Days: "Don't ask for this code for {{days}} days",
  tfAuthCodeInput: 'Enter the code from your authentication app',
  tfValidatePasswordError: 'Incorrect password',
  tfSuccessTitle: 'All set!',
  tfSuccessDescription:
    'Two-factor authentication is now enabled for your account. Now you can use the mobile authentication app to get an authentication code any time you log in yo EFEX.',
  tfDisableTitle: 'Disable Two-Factor Authentication',
  tfDisableSubtitle: 'You already have two-factor authentication enabled',
  tdDisableDescription:
    'Are you sure you want to disable two-factor authentication?',
  tdDisableConfirmation: 'Disable',
  tfDisableSuccessTitle: 'Two-Factor Authentication Disabled',
  tfDisableSuccessDescription:
    'Two-factor authentication has been disabled for your account.',
  tfConfirmationCodeRecovery: 'Do you lost your otp device?',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const SECURITY_TWO_FACTOR_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    tfTitle: 'Autenticación de dos factores',
    tfDescription:
      'Ayuda a proteger su cuenta contra el acceso no autorizado habilitando controles de seguridad adicionales al iniciar sesión. Deberá ingresar su contraseña y un código de verificación de su teléfono para iniciar sesión.',
    tfCTA: 'Configurar autenticación de dos factores',
    tfCTADisable: 'Deshabilitar autenticación de dos factores',
    tfConfigTitle: 'Proteja su cuenta en solo unos pocos pasos',
    tfConfigStep1:
      'Vincule una aplicación de autenticación a su cuenta de EFEX',
    tfConfigStep1Description: `Use una aplicación de autenticación compatible (como Google Authenticator, Authy Duo Mobile, 1Password, etc.) Generaremos un código QR para que lo escanee.`,
    tfConfigStep2: 'Ingrese el código de confirmación',
    tfConfigStep2Description:
      'La autenticación de dos factores se activará para la aplicación de autenticación.',
    tfCodeScan:
      'Use su aplicación de autenticación para escanear el código QR. Si no tiene una aplicación de autenticación, deberá instalar una para continuar.',
    tfCodeScanError:
      'Se produjo un error al recuperar el código QR. Por favor, inténtelo de nuevo más tarde.',
    tfCodeCantScan: 'No puedes escanear el código QR?',
    tfCodeManualConfig:
      'Introduce el siguiente código en tu aplicación de autenticación:',
    tfConfirmationCode:
      'Ingrese el código de confirmación generado por su aplicación de autenticación.',
    tfConfirmationCodeError: 'Código no válido, inténtelo de nuevo.',
    tfDisable90Days: 'No solicitar este código durante {{days}} días',
    tfAuthCodeInput: 'Ingrese el código de su aplicación de autenticación',
    tfValidatePasswordError: 'Contraseña incorrecta',
    tfSuccessTitle: '¡Todo listo!',
    tfSuccessDescription:
      'La autenticación de dos factores ahora está habilitada para su cuenta. Ahora puede usar la aplicación de autenticación móvil para obtener un código de autenticación cada vez que inicie sesión en EFEX.',
    tfDisableTitle: 'Deshabilitar autenticación de dos factores',
    tfDisableSubtitle: 'Ya tiene habilitada la autenticación de dos factores',
    tdDisableDescription:
      '¿Está seguro de que desea deshabilitar la autenticación de dos factores?',
    tdDisableConfirmation: 'Deshabilitar',
    tfDisableSuccessTitle: 'Autenticación de dos factores deshabilitada',
    tfDisableSuccessDescription:
      'La autenticación de dos factores se ha deshabilitado para su cuenta.',
    tfConfirmationCodeRecovery: '¿Perdiste tu dispositivo otp?',
  },
};

export default SECURITY_TWO_FACTOR_LANGUAGE_LABELS;
